import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonToolbar, ButtonGroup, Button, Card } from "react-bootstrap";
import { setScopeDirty } from "../../actions/generic/scopeActions";
import FuseAttachment from "./FuseAttachmentPicker";

class FuseToolbar extends Component {
  state = {};

  render() {
    const { current } = this.state;
    return (
      // <Card key="panel-toolbar" className="card-box">
      //   <Card.Body>
      <ButtonToolbar aria-label="Toolbar with button groups">
        <Button
          className="mr-1 shadow-sm"
          variant="secondary"
          hidden={!this.props.showBack}
          disabled={this.props.backDisabled}
          onClick={this.props.onBackClicked}
        >
          <i className="fa fa-arrow-left" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="success"
          hidden={!this.props.showAdd}
          disabled={this.props.addDisabled}
          onClick={this.props.onAddClicked}
        >
          <i className="fa fa-plus" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="light"
          hidden={!this.props.showCopy}
          disabled={this.props.copyDisabled}
          onClick={this.props.onCopyClicked}
        >
          <i className="fa fa-copy" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="info"
          type="submit"
          hidden={!this.props.showSave}
          disabled={this.props.saveDisabled}
          onClick={this.props.onSaveClicked}
        >
          <i className="fa fa-save" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="warning"
          hidden={!this.props.showEdit}
          disabled={this.props.editDisabled}
          onClick={this.props.onEditClicked}
        >
          <i className="fa fa-edit" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="warning"
          hidden={!this.props.showUndo}
          disabled={this.props.undoDisabled}
          onClick={this.props.onUndoClicked}
        >
          <i className="fa fa-undo" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="danger"
          hidden={!this.props.showDelete}
          disabled={this.props.deleteDisabled}
          onClick={this.props.onDeleteClicked}
        >
          <i className="fa fa-trash" />
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="info"
          hidden={!this.props.showRefresh}
          disabled={this.props.refreshDisabled}
          onClick={this.props.onRefreshClicked}
        >
          <i className="fa fa-sync-alt" />
        </Button>
        <Button
          className="btn-sm shadow-sm"
          onClick={(e) => {
            this.props.setScopeDirty(!this.props.scopeIsDirty);
          }}
          hidden={!this.props.showDemoScope}
        >
          Test: Dirty scope: {this.props.scopeIsDirty ? "Y" : "N"}
        </Button>   
        <FuseAttachment
          showAsButton={this.props.showAsButton || true}
          hidden={!this.props.showAttachment}
          disabled={this.props.attachmentDisabled}
          sourceKey={this.props.attachment}
          attachmentMask={null}
          onUpdateSourceKey={this.props.onUpdateSourceKey}
          isInEdit={!this.props.showEdit}
        />

        {/* Approval and assign group buttons */}
        <Button
          className="mr-1 shadow-sm"
          variant="info"
          hidden={!this.props.showAssignToGroup}
          disabled={this.props.assignToGroupDisabled}
          onClick={this.props.onAssignToGroupClicked}
        >
          <i className="fa fa-user-plus" /> Assign
        </Button>

        <Button
          className="mr-1 shadow-sm"
          variant="warning"
          hidden={!this.props.showRequestApproval}
          disabled={this.props.requestApprovalDisabled}
          onClick={this.props.onRequestApprovalClicked}
        >
          <i className="fa fa-user-check" /> Request Approval
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="success"
          hidden={!this.props.showApprove}
          disabled={this.props.approveDisabled}
          onClick={this.props.onApproveClicked}
        >
          <i className="fa fa-check" /> Approve
        </Button>
        <Button
          className="mr-1 shadow-sm"
          variant="danger"
          hidden={!this.props.showReject}
          disabled={this.props.rejectDisabled}
          onClick={this.props.onRejectClicked}
        >
          <i className="fa fa-times" /> Reject
        </Button>
      </ButtonToolbar>
      //   </Card.Body>
      // </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    scopeIsDirty: state.scope.isDirty,
  };
};

export default connect(
  // map state to props
  mapStateToProps,
  // map dispatch to props
  (dispatch, ownProps) => ({
    setScopeDirty: (isDirty) => dispatch(setScopeDirty(isDirty)),
  })
)(FuseToolbar);
